module.exports = __webpack_public_path__ + "img/orange_019.3f11d5d7.png";